(() => {
  const searchParams = new URLSearchParams(window.location.search);
  const availabilityFilterKey = "filter.v.m.zoa.is_available";
  const availabilityFilter = searchParams.get(availabilityFilterKey);
  const availabilityToggle = document.querySelector("[data-zoa-availability-filter]");
  if (availabilityFilter) {
    return;
  }
  if (!availabilityToggle || !availabilityToggle.checked) {
    return;
  }

  searchParams.set(availabilityFilterKey, "1");
  searchParams.delete("phcursor");
  window.history.replaceState(null, "",`${window.location.pathname}?${searchParams}`);
})();
